/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import useStyles from "./useStyles";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import VisitorsContext from "./VisitorsContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";

const headCells = [
    { index: 1, id: "firstName", disablePadding: false, label: "First Name" },
    { index: 2, id: "lastName", disablePadding: false, label: "Last Name" },
    { index: 3, id: "homePhone", disablePadding: true, label: "Home Phone" },
    { index: 4, id: "dobString", orderBy: "dob", disablePadding: true, label: "Date of Birth" },
    { index: 5, id: "visitDateString", orderBy: "visitDate", disablePadding: true, label: "Visit Date" },
];

function List({ history }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "firstName",
        orderDirection: "asc",
        pageNumber: 0,
        pageSize: 5,
    };

    const Visitors = useContext(VisitorsContext);

    function getVisitors(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Visitors.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getVisitors();

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/visitors/${item.id}`);
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getVisitors();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Visitors.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  firstName: filterValue,
                  lastName: filterValue,
                  homePhone: filterValue,
              }
            : {};
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="Visitors">
                        <Button primary onClick={() => history.push("/visitors/add")}>
                            <Icon name="add" size="md" color="white" />
                            <span>Add</span>
                        </Button>
                    </Header>
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            title="Visitors"
                            dense={false}
                            defaultOrder={{ order: "asc", orderBy: "firstName" }}
                            keyColumnName="id"
                            selectable
                            onRowClick={onRowClickHandler}
                            onDelete={onDeleteHandler}
                            onRequestData={getVisitors}
                            filterBuilder={filterBuilder}
                            pageableData={pageableData}
                        />
                    </div>
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
